import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FilterListIcon from "@material-ui/icons/FilterList";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  pillWrapper: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.total,
    borderRadius: 24,
    padding: "2px 4px 2px 10px",
    gap: 4,
    minWidth: 130,
    maxWidth: 170,
    height: 32,
    flexShrink: 0,
    cursor: "pointer",
  },
  filterIcon: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    flexShrink: 0,
  },
  select: {
    flex: 1,
    fontSize: "0.8rem",
    color: theme.palette.text.secondary,
    "& .MuiSelect-select": {
      padding: "0 !important",
      paddingRight: "20px !important",
      background: "transparent",
    },
    "& .MuiSelect-icon": {
      right: 0,
      color: theme.palette.text.secondary,
    },
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const renderValue = () => {
    const total = userQueues?.length ?? 0;
    const selected = selectedQueueIds.length;
    if (total === 0 || selected === total) return i18n.t("ticketsQueueSelect.placeholder");
    if (selected === 1) {
      const q = userQueues.find((q) => q.id === selectedQueueIds[0]);
      return q ? q.name : "1 fila";
    }
    return `${selected} filas`;
  };

  return (
    <div className={classes.pillWrapper}>
      <FilterListIcon className={classes.filterIcon} />
      <Select
        multiple
        displayEmpty
        disableUnderline
        variant="standard"
        className={classes.select}
        value={selectedQueueIds}
        onChange={handleChange}
        renderValue={renderValue}
        MenuProps={{
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          getContentAnchorEl: null,
        }}
      >
        {userQueues?.length > 0 &&
          userQueues.map((queue) => (
            <MenuItem dense key={queue.id} value={queue.id}>
              <Checkbox
                style={{ color: queue.color }}
                size="small"
                color="primary"
                checked={selectedQueueIds.indexOf(queue.id) > -1}
              />
              <ListItemText primary={queue.name} />
            </MenuItem>
          ))}
      </Select>
    </div>
  );
};

export default TicketsQueueSelect;
